import _ from 'lodash'

export const getId = string =>
  _(string)
    .split('-')
    .last()

export default ({ name, id }) => {
  return name ? name.replace(/ /g, '-') + '-' + id : '#'
}
